/**
 * Client-side secure-proxy handshake recovery — now a thin re-export of the shared
 * implementation in `@breetometer/utils/secure-proxy/client`. The logic (recover
 * only a 403 carrying a nonce-lost SPX code, only after the 419 promotion, at most
 * once) and its rationale live there; this module keeps the import path stable for
 * `apiSlice.ts` and the colocated tests.
 */
import { RECOVERABLE_SECURE_PROXY_STATUS_CODES } from '@breetometer/utils/secure-proxy/client';
import { SECURE_PROXY_ENV_HEADER_NAME } from '@breetometer/utils/secure-proxy/protocol';
import { ENV_TARGET_KEY } from 'BreetHelpers';

export {
	createClientHandshakeTelemetry,
	extractRetryEvidence,
	extractSecureProxyStatusCode,
	type RetryEvidence,
	SECURE_PROXY_CHALLENGE_HEADER_NAME,
	SECURE_PROXY_TICKET_HEADER_NAME,
	shouldRecoverHandshake,
	TrustedAppIds,
} from '@breetometer/utils/secure-proxy/client';

/** The two nonce-lost SPX codes the client heals with one full handshake re-run. */
export const HANDSHAKE_RECOVERABLE_CODES: ReadonlySet<string> = new Set(RECOVERABLE_SECURE_PROXY_STATUS_CODES);

/** Preserve the server-validated environment that minted the one-time evidence. */
export const preserveRetryEnvironment = (retryHeaders: Headers, evidenceHeaders: Headers | undefined): void => {
	const environment = evidenceHeaders?.get(SECURE_PROXY_ENV_HEADER_NAME)?.trim();
	if (environment) {
		retryHeaders.set(ENV_TARGET_KEY, environment);
	}
};
